export const postsQuery = `
  *[_type == "post" && language == $language && defined(slug.current)] | order(publishedAt desc) {
    _id,
    title,
    "slug": slug.current,
    excerpt,
    publishedAt,
    mainImage,
    language,
    translationKey
  }
`;

export const postBySlugQuery = `
  coalesce(
    *[_type == "post" && slug.current == $slug && language == $language][0],
    *[_type == "post" && language == $language && translationKey == *[_type == "post" && slug.current == $slug][0].translationKey][0]
  ) {
    _id,
    title,
    "slug": slug.current,
    excerpt,
    publishedAt,
    mainImage,
    body,
    seoDescription,
    language,
    translationKey
  }
`;

export const allPostSlugsQuery = `
  *[_type == "post" && defined(slug.current)] {
    "slug": slug.current,
    publishedAt
  }
`;
